import { gql } from '@apollo/client';

export default gql`
  query GetSeatsByToken($token: String!, $subscriptionId: MongoID!) {
    getSeatsByToken(token: $token, subscriptionId: $subscriptionId) {
      current
      pricePerSeat
      period
      total
      history {
        date
        quantity
        amount
      }
      historyCount
      page
      perPage
    }
  }
`;
